import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { NotificationTemplateModel } from './model';
import { NotificationTemplateState } from './state';
import * as selectors from './selectors';
import * as actions from './actions';
import { UserFacade } from '../user/facade';

@Injectable()
export class NotificationTemplateFacade {
  private store = inject<Store<NotificationTemplateState>>(Store);
  private userFacade = inject(UserFacade);

  allTemplates$ = this.store.pipe(select(selectors.selectAll));
  parameters$ = this.store.pipe(select(selectors.selectParameters));

  constructor() {
    this.userFacade.selected().subscribe(user => {
      if (user) {
        this.getAll();
      }
    });
  }

  public getAll() {
    this.store.dispatch(new actions.LoadRequestAction());
  }

  getById(id: number): Observable<NotificationTemplateModel> {
    return this.store.pipe(select(selectors.selectById(id)));
  }

  loadTemplates() {
    this.store.dispatch(new actions.LoadRequestAction());
  }

  saveTemplate(template: NotificationTemplateModel) {
    this.store.dispatch(new actions.SaveRequestAction(template));
  }

  selected(): Observable<NotificationTemplateModel> {
    return this.store.pipe(select(selectors.selectSelected));
  }

  getError(): Observable<any> {
    return this.store.pipe(select(selectors.selectError));
  }

  isLoading(): Observable<boolean> {
    return this.store.pipe(select(selectors.selectIsLoading));
  }

  loadParameters() {
    this.store.dispatch(new actions.LoadParametersRequestAction());
  }
}
